module.exports = __webpack_public_path__ + "media/st-2.1fd9698d.mp4";